import * as AWDStatusActions from 'ApplicationEntry/ducks/AWDStatus';
import {isLoaded, isLoading, matchUnderwriter, Underwriter} from 'ApplicationEntry/models/AWDStatus/Underwriter';
import {StringUnion} from 'Core/models/EmptyString';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {WorkQueueItem} from 'ApplicationEntry/models/WorkQueueItem';
import './AWDStatus.sass';

import {CircularProgress, FormControl, InputLabel, MenuItem, Select, Grid} from '@material-ui/core';

type StatusProps = {
  underwriterList: Underwriter;
  underwriter: StringUnion;
  underwriter2: StringUnion;
  underwriter3: StringUnion;
  workItemList?: WorkQueueItem[];
  underWriterRowNo: number;
};

const UnderWriterView = (props: StatusProps) => {
  const [awdStatusLabel, setAWDStatusLabel] = useState<HTMLLabelElement | null>();
  const dispatch = useDispatch();
  const {underwriter, underwriter2, underwriter3, underwriterList} = props;

  const changeUnderWriterType = (underWriter: string, idx: number) => {
    if (idx == 0) {
      dispatch(AWDStatusActions.changeUnderwriter(underWriter));
    } else if (idx == 1) {
      dispatch(AWDStatusActions.changeUnderwriter2(underWriter));
    } else if (idx == 2) {
      dispatch(AWDStatusActions.changeUnderwriter3(underWriter));
    }
  };

  const getUnderWriterType = (rowNo: number) => {
    if (rowNo == 0) {
      return underwriter.value;
    } else if (rowNo == 1) {
      return underwriter2.value;
    } else if (rowNo == 2) {
      return underwriter3.value;
    }
  };
  return (
    <>
      {matchUnderwriter({
        Loading: () => (
          <Grid item xs={12} md={3}>
            <FormControl variant="outlined" className="awdStatus-section__view-form-text-field">
              <InputLabel ref={setAWDStatusLabel} id="awdStatus-underwriter-label">
                Underwriter
              </InputLabel>
              <Select
                labelId="awdStatus-label-underwriter"
                labelWidth={awdStatusLabel?.clientWidth}
                id="awdStatus-underwriter"
                value={underwriter.value}
                onChange={e => dispatch(AWDStatusActions.changeUnderwriter(e.target.value as string))}
                displayEmpty
              >
                <MenuItem value="">&nbsp;&nbsp;</MenuItem>
              </Select>
              {isLoading(underwriterList) ? (
                <CircularProgress className="awdStatus-section__view-form-loading-icon" />
              ) : null}
            </FormControl>
          </Grid>
        ),
        Loaded: pn => (
          <Grid item xs={12} md={3}>
            <FormControl variant="outlined" className="awdStatus-section__view-form-text-field">
              <InputLabel ref={setAWDStatusLabel} id="awdStatus-underwriter-label">
                Underwriter
              </InputLabel>
              <Select
                labelId="awdStatus-label-underwriter"
                labelWidth={awdStatusLabel?.clientWidth}
                id="awdStatus-underwriter"
                value={getUnderWriterType(props.underWriterRowNo)}
                onChange={e => changeUnderWriterType(e.target.value as string, props.underWriterRowNo)}
                displayEmpty
              >
                {isLoaded(underwriterList) ? (
                  underwriterList.Data.map(rel => (
                    <MenuItem value={rel} key={rel}>
                      {rel}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">&nbsp;&nbsp;</MenuItem>
                )}
              </Select>
              {isLoading(underwriterList) ? (
                <CircularProgress className="awdStatus-section__view-form-loading-icon" />
              ) : null}
            </FormControl>
          </Grid>
        ),
        Unassigned: () => (
          <Grid item xs={12} md={3}>
            <FormControl variant="outlined" className="awdStatus-section__view-form-text-field">
              <InputLabel ref={setAWDStatusLabel} id="awdStatus-underwriter-label">
                Underwriter
              </InputLabel>
              <Select
                labelId="awdStatus-label-underwriter"
                labelWidth={awdStatusLabel?.clientWidth}
                id="awdStatus-underwriter"
                value={underwriter.value}
                onChange={e => dispatch(AWDStatusActions.changeUnderwriter(e.target.value as string))}
                displayEmpty
              >
                <MenuItem value="">&nbsp;&nbsp;</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        ),
        Error: () => (
          <Grid item xs={12} md={3}>
            <FormControl error variant="outlined" className="awdStatus-section__view-form-text-field">
              <InputLabel ref={setAWDStatusLabel} id="awdStatus-underwriter-label">
                Underwriter
              </InputLabel>
              <Select
                labelId="awdStatus-label-underwriter"
                labelWidth={awdStatusLabel?.clientWidth}
                id="awdStatus-underwriter"
                value={underwriter.value}
                onChange={e => dispatch(AWDStatusActions.changeUnderwriter(e.target.value as string))}
                displayEmpty
              >
                <MenuItem value="">&nbsp;&nbsp;</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        ),
      })(underwriterList)}
    </>
  );
};

export default UnderWriterView;
